export interface Attribute {
    code: string;
    label: string;
    inputType: AttributeInputType;
    isSearchable: boolean;
    isVisible: boolean;
    options: AttributeOption[];
}

export enum AttributeInputType {
    SELECT,
    TEXT,
    BOOLEAN,
    PRICE
}

export interface AttributeOption {
    label: string;
    value: string;
}

export interface AttributeDictionary {
    [code: string]: Attribute;
}
